import type { DocNetMission } from 'src/@types/docnet';

export const mockMissions: DocNetMission[] = [
  {
    id: 'M1',
    name: 'Q1 Invoice Automation',
    description: 'Automate end-to-end invoice processing for EU region. Target: 95% straight-through rate by end of Q1.',
    status: 'active',
    level: 'organization',
    owner_id: 'A4',
    owner_name: 'Orchestrator Agent',
    member_ids: ['A1', 'A2', 'A3', 'A4'],
    issues: [
      { id: 'I1', title: 'Validate invoice SI-2024-78945 header fields', status: 'in_progress', priority: 'high', type: 'task' },
      { id: 'I2', title: 'Classify unknown document batch #4021', status: 'todo', priority: 'medium', type: 'task' },
      { id: 'I3', title: 'PO matching for order PO-2024-0871', status: 'in_review', priority: 'high', type: 'review' },
      { id: 'I6', title: 'Blocked: Missing tax code mapping for IT region', status: 'error', priority: 'critical', type: 'escalation' },
      { id: 'I8', title: 'Extract line items from delivery note DN-8891', status: 'done', priority: 'medium', type: 'bug' },
    ],
    sub_missions: [],
    project_id: 'P1',
    created_on: '2025-01-15T08:00:00Z',
    last_modified_on: '2025-03-14T14:30:00Z',
    due_date: '2025-03-31',
  },
  {
    id: 'M2',
    name: 'Supplier Onboarding Sprint',
    description: 'Onboard 10 new suppliers with automated document exchange and EDI configuration.',
    status: 'active',
    level: 'team',
    owner_id: 'A4',
    owner_name: 'Orchestrator Agent',
    member_ids: ['A1', 'A4'],
    issues: [
      { id: 'I4', title: 'Onboard supplier Global Parts Inc.', status: 'in_progress', priority: 'medium', type: 'task' },
      { id: 'I5', title: 'Review extraction accuracy report', status: 'backlog', priority: 'low', type: 'review' },
    ],
    sub_missions: [],
    project_id: 'P1',
    created_on: '2025-02-01T08:00:00Z',
    last_modified_on: '2025-03-14T10:00:00Z',
    due_date: '2025-04-15',
  },
  {
    id: 'M3',
    name: 'Document Classification Model v2',
    description: 'Train and deploy improved classification model with support for 15 new document types.',
    status: 'planning',
    level: 'sub_organization',
    owner_id: 'A2',
    owner_name: 'Classifier Agent',
    member_ids: ['A2'],
    issues: [],
    sub_missions: [],
    project_id: 'P2',
    created_on: '2025-03-01T08:00:00Z',
    last_modified_on: '2025-03-10T08:00:00Z',
    due_date: '2025-06-30',
  },
  {
    id: 'M4',
    name: 'Legacy Invoice Migration',
    description: 'Migrate 50,000 legacy invoices from old system. Completed extraction and validation.',
    status: 'completed',
    level: 'organization',
    owner_id: 'A1',
    owner_name: 'Extractor Agent',
    member_ids: ['A1', 'A3'],
    issues: [],
    sub_missions: [],
    project_id: 'P1',
    created_on: '2024-10-01T08:00:00Z',
    last_modified_on: '2025-02-28T18:00:00Z',
  },
];
